import { Component, HostBinding, HostListener, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { Task } from 'src/app/tasks/shared/models';

import { MassActionsService } from '../mass-actions/mass-actions.service';
import { QueueIdEnum, TaskListModeEnum } from '../shared/enums';
import { TaskListConfiguration } from '../shared/models';

@Component({
  selector: 'app-task-selection',
  templateUrl: './task-selection.component.html',
  styleUrls: ['./task-selection.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskSelectionComponent implements OnChanges {
  @Input() task: Task;
  @Input() taskListConfiguration: TaskListConfiguration;
  @Input() taskListMode: TaskListModeEnum;

  @HostBinding('class.disabled') get isDisabled() {
    return this.task.isNotSelectable;
  }

  @HostListener('click', ['$event.target']) onClick(target: any) {
    this.selectTaskOnHostClick(target);
  }

  constructor(private massActionsService: MassActionsService) {}

  ngOnChanges(): void {
    const excludedFromSelection = [
      QueueIdEnum.AnsweredByMe,
      QueueIdEnum.AnsweredByOthers,
      QueueIdEnum.ArchivedByMe,
      QueueIdEnum.ArchivedByOthers,
    ];

    if (
      this.taskListMode === TaskListModeEnum.Inbox &&
      excludedFromSelection.includes(this.taskListConfiguration.queueId as QueueIdEnum)
    ) {
      this.task.isNotSelectable = true;
    }
  }

  selectTaskOnHostClick(target: any) {
    // SPAN is span.mat-checkbox-inner-container, but don't put class in hard, because if one day angular change the class name it will be broken (but span could change too...)
    if (!this.task.isNotSelectable && target.nodeName !== 'SPAN') {
      this.task.isChecked = !this.task.isChecked;
      this.selectTask();
    }
  }

  selectTask() {
    this.massActionsService.toggleOneTask(this.task.isChecked, this.task.id);
  }
}
